// import { formatToMonthDayYear } from "@workspace/lib/date"
// import { Button, buttonVariants } from "@workspace/web-ui/components/button"
// import {
//     Table,
//     TableBody,
//     TableCell,
//     TableHead,
//     TableHeader,
//     TableRow
// } from "@workspace/web-ui/components/table"
// import { useState } from "react";
// import { PaymentDetailsSheet } from "./payment-details-sheet";
// import { useSendInvoiceMutation } from "../../encounters/api/mutations";
// import { getRouteApi, Link } from "@tanstack/react-router";
// import { cn } from "@workspace/web-ui/lib/utils";
  
//   export interface PaymentHistoryTableProps {
//     data: {
//       userName: string,
//       paymentDate: string,
//       description: string,
//       amount: number,
//       status: string,
//       paymentType: string,
//       userId: string,
//       typeId: string,
//     }[]
//   }
  
//   const PaymentHistoryTable = ({ data }: PaymentHistoryTableProps) => {
//     const [openSheet, setOpenSheet] = useState(false);
//     const [selectedPayment, setSelectedPayment] = useState<{ userId: string; typeId: string; type: string } | null>(null);
//     const [, setInvoiceSent] = useState(false);
//     const {mutate:sendInvoiceMutation, isPending} = useSendInvoiceMutation();
//     const [clickedMedication, setClickedMedication] = useState<{ userId: string; typeId: string; type: string } | null>(null)
//     const routeApi = getRouteApi("/(dashboard)/dashboard/$program");
//     const { program } = routeApi.useParams();
    
//     const handleSeeDetails = (userId: string, typeId: string, type: string) => {
//       console.log("typeinital", )
//       setSelectedPayment({ userId, typeId, type });
//       setOpenSheet(true);
//     };

//     const handleCloseSheet = () => {
//       setOpenSheet(false);
//       setSelectedPayment(null);
//     };

//     const handleSendInvoice = async (userId: string, typeId: string, type: string) => {
//       try {
//         setClickedMedication({ userId, typeId, type })
//         await sendInvoiceMutation({ patient_id: userId, type_id: typeId, type: type });
//         setInvoiceSent(true);
//       } catch (e) {
//         // handle error
//       }
//     };

//     return (
//       <>
//         <Table className="border rounded-[16px]">
//           <TableHeader>
//             <TableRow>
//               <TableHead>Patient name</TableHead>
//               <TableHead>Description</TableHead>
//               <TableHead>Date</TableHead>
//               <TableHead>Amount</TableHead>
//               <TableHead>Status</TableHead>
//               <TableHead></TableHead>
//             </TableRow>
//           </TableHeader>
//           <TableBody>
//             {data.map((payment, index) => (
//               <TableRow key={index}>
//                 <TableCell className="font-medium">{payment.userName}</TableCell>
//                 <TableCell className="font-medium">{payment.description}</TableCell>
//                 <TableCell className="font-medium">{formatToMonthDayYear(payment.paymentDate) }</TableCell>
//                 <TableCell>${payment.amount}</TableCell>
//                 <TableCell>
//                   <span className={`px-2 py-1 rounded-full text-xs ${
//                     payment.status === 'paid' ? 'bg-green-100 text-green-500' : 'bg-yellow-100 text-yellow-500'
//                   }`}>
//                     {payment.status}
//                   </span>
//                 </TableCell>
//                 <TableCell className="flex items-end justify-end">
//                   {payment.paymentType === "Prescription" ? (
//                     <div className="flex gap-2 items-center">
//                       <Button className="bg-transparent hover:bg-transparent border-dotted shadow-none text-[#4272DD]" onClick={() => handleSeeDetails(payment.userId, payment.typeId, payment.paymentType)}>See details</Button>
//                       <Button
//                         className="rounded-[8px] bg-[#4272DD] flex items-center gap-2"
//                         onClick={() => handleSendInvoice(payment.userId, payment.typeId, payment.paymentType)}
//                         disabled={!!(
//                           isPending && clickedMedication &&
//                           clickedMedication.userId === payment.userId &&
//                           clickedMedication.typeId === payment.typeId &&
//                           clickedMedication.type === payment.paymentType
//                         )}
//                       >
//                         {isPending && clickedMedication &&
//                           clickedMedication.userId === payment.userId &&
//                           clickedMedication.typeId === payment.typeId &&
//                           clickedMedication.type === payment.paymentType && (
//                             <svg className="animate-spin h-4 w-4 text-white mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                               <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                               <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
//                             </svg>
//                           )
//                         }
//                         Send Invoice
//                       </Button>
//                     </div>
//                   ) : (
//                     // <Button className="rounded-[8px] bg-white border border-[#4272DD] hover:bg-transparent text-[#4272DD]">View Patient Log</Button>
//                     <Link
//                     onClick={() => setOpenSheet(false)}
//                     className={cn(buttonVariants({ variant: "outline" }), "w-fit rounded-[8px] bg-white border border-[#4272DD] hover:bg-transparent text-[#4272DD] hover:text-[#4272DD]")}
//                     to="/dashboard/$program/patients/patient/$id"
//                     params={{
//                         id: payment.userId,
//                         program
//                     }}
//                     search={{
//                         name: payment.userName.replace(/\s+/g, "")
//                     }}
//                 >
//                     View Patient Log
//                 </Link>
//                   )}
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//         {/* Payment Details Sheet */}
//         {openSheet && selectedPayment && (
//           <PaymentDetailsSheet
//             open={openSheet}
//             onOpenChange={handleCloseSheet}
//             patientId={selectedPayment.userId}
//             typeId={selectedPayment.typeId}
//             type={selectedPayment.type}
//           />
//         )}
//       </>
//     )
//   }

//   export default PaymentHistoryTable


import { formatToMonthDayYear } from "@workspace/lib/date"
import { Button, buttonVariants } from "@workspace/web-ui/components/button"
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow
} from "@workspace/web-ui/components/table"
import { useState } from "react";
import { PaymentDetailsSheet } from "./payment-details-sheet";
import { useSendInvoiceMutation } from "../../encounters/api/mutations";
import { getRouteApi, Link } from "@tanstack/react-router";
import { cn } from "@workspace/web-ui/lib/utils";
  
  export interface PaymentHistoryTableProps {
    data: {
      userName: string,
      paymentDate: string,
      description: string,
      amount: number,
      status: string,
      paymentType: string,
      userId: string,
      typeId: string,
      encounterId?: string,
      deliveryStatus: string
    }[]
  }

const PaymentHistoryTable = ({ data }: PaymentHistoryTableProps) => {
  const [openSheet, setOpenSheet] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState<{ userId: string; typeId: string; type: string; deliveryStatus: string; status: string } | null>(null);

  // NEW: Track "sent" per payment row
  // const [invoiceSentByPayment, setInvoiceSentByPayment] = useState<Record<string, boolean>>({});

  // const keyFor = (userId: string, typeId: string, type: string) => `${userId}:${typeId}:${type}`;

  const { mutate: sendInvoiceMutation, isPending } = useSendInvoiceMutation();
  const [clickedMedication, setClickedMedication] = useState<{ userId: string; typeId: string; type: string } | null>(null);

  const routeApi = getRouteApi("/(dashboard)/dashboard/$program");
  const { program } = routeApi.useParams();

  const handleSeeDetails = (userId: string, typeId: string, type: string, deliveryStatus: string, status: string) => {
    setSelectedPayment({ userId, typeId, type, deliveryStatus, status });
    setOpenSheet(true);
  };

  const handleCloseSheet = () => {
    setOpenSheet(false);
    setSelectedPayment(null);
  };

  // When sending from the TABLE button
  const handleSendInvoice = async (userId: string, typeId: string, type: string) => {
    try {
      setClickedMedication({ userId, typeId, type });
      await sendInvoiceMutation({ patient_id: userId, type_id: typeId, type });
      // Mark this payment as "sent"
      // const k = keyFor(userId, typeId, type);
      // setInvoiceSentByPayment(prev => ({ ...prev, [k]: true }));
    } catch (e) {
      // handle error
    }
  };

  return (
    <>
      <Table className="border rounded-[16px]">
        <TableHeader>
          <TableRow>
            <TableHead>Patient name</TableHead>
            <TableHead>Description</TableHead>
            <TableHead>Date</TableHead>
            <TableHead>Amount</TableHead>
            <TableHead>Status</TableHead>
            <TableHead></TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {data.map((payment, index) => {
            const isThisRowPending =
              !!(isPending &&
                clickedMedication &&
                clickedMedication.userId === payment.userId &&
                clickedMedication.typeId === payment.typeId &&
                clickedMedication.type === payment.paymentType);

            return (
              <TableRow key={index}>
                <TableCell className="font-medium">{payment?.userName}</TableCell>
                <TableCell className="font-medium">
                  {payment.description === "Medication Refill" ? "Refill Prescription" : payment.description}
                </TableCell>
                <TableCell className="font-medium">{formatToMonthDayYear(payment.paymentDate)}</TableCell>
                <TableCell>${payment.amount}</TableCell>
                <TableCell>
                  <span
                    className={`px-2 py-1 rounded-full text-xs ${
                      payment.status === "paid"
                        ? "bg-green-100 text-green-500"
                        : "bg-yellow-100 text-yellow-500"
                    }`}
                  >
                    {payment.status}
                  </span>
                </TableCell>

                <TableCell className="flex items-end justify-end">
                  {payment.paymentType === "Prescription" ? (
                    <div className="flex gap-2 items-center">
                      <Button
                        className="bg-transparent hover:bg-transparent border-dotted shadow-none text-[#4272DD]"
                        onClick={() => handleSeeDetails(payment.userId, payment.typeId, payment.paymentType, payment.deliveryStatus, payment.status)}
                      >
                        See details
                      </Button>

                      <Button
                        className="rounded-[8px] bg-[#4272DD] flex items-center gap-2"
                        onClick={() => handleSendInvoice(payment.userId, payment.typeId, payment.paymentType)}
                        // Keep disabled ONLY while this row is sending (prevents double-click) OR if payment is not paid
                        disabled={isThisRowPending || payment.status !== "paid"}
                      >
                        {isThisRowPending && (
                          <svg
                            className="animate-spin h-4 w-4 text-white mr-2"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                            ></path>
                          </svg>
                        )}
                        {/* LABEL: stays "Resend Invoice" after first send */}
                        {payment.deliveryStatus === "sent" ? "Resend Invoice" : "Send Invoice"}
                      </Button>
                    </div>
                  ) : (
                    <Link
                      onClick={() => setOpenSheet(false)}
                      className={cn(
                        buttonVariants({ variant: "outline" }),
                        "w-fit rounded-[8px] bg-white border border-[#4272DD] hover:bg-transparent text-[#4272DD] hover:text-[#4272DD]"
                      )}
                      to="/dashboard/$program/encounters/encounter/$id"
                      params={{
                        id: payment.encounterId ?? "",
                        program,
                      }}
                      search={{
                        name:
                          payment.description === "Live Consultation"
                            ? "liveconsultation"
                            : payment.paymentType
                                ?.toLowerCase()
                                .replace(/\s+/g, "")
                                .replace(/^express/, ""),
                        patientId: payment.userId,
                      }}
                    >
                      View Encounter
                    </Link>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>

      {/* Payment Details Sheet */}
      {openSheet && selectedPayment && (
        <PaymentDetailsSheet
          open={openSheet}
          onOpenChange={handleCloseSheet}
          patientId={selectedPayment.userId}
          typeId={selectedPayment.typeId}
          type={selectedPayment.type}
          deliveryStatus={selectedPayment.deliveryStatus}
          program={program}
          status={selectedPayment.status}
        />
      )}
    </>
  );
};

export default PaymentHistoryTable;
